import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useNavigationType, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Footer from '../../../../../components/home_page/Footer';
import '../alter.css';
import { saveChartOfAccountsState } from '../../../../../redux/actions/action-creator';
import { useDropdownScroll } from '../../../../../components/Custom_Hooks/useDropdownScroll';

function GroupList() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const navigationType = useNavigationType();
    const location = useLocation();
    
    const { data = [] } = useSelector(state => state.common);
    const persistedState = useSelector(state => state.common.chart_of_accounts_persisted_state?.group);
    
    const [selectedIndex, setSelectedIndex] = useState(0);
    const isBackNavigation = navigationType === 'POP';
    const localSelectionRef = useRef(null);
    const dropdownRef = useRef(null);

    // Filtered data keys for easier mapping
    const dataKeys = Object.keys(data);
    const totalLinks = dataKeys.length;

    useEffect(() => {
        const itemNameToRestore = isBackNavigation ? persistedState?.selectedItemName : localSelectionRef.current;
        if (itemNameToRestore) {
            const index = dataKeys.findIndex(key => data[key]?.name === itemNameToRestore);
            if (index !== -1) setSelectedIndex(index);
            else setSelectedIndex(0);
        } else {
            setSelectedIndex(0);
        }
        
        
    }, [location, data]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                setSelectedIndex((prevIndex) => (prevIndex + 1) % totalLinks);
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                setSelectedIndex((prevIndex) => (prevIndex - 1 + totalLinks) % totalLinks);
            } else if (event.key === 'Enter') {
                const selectedKey = dataKeys[selectedIndex];
                const selectedLink = data[selectedKey];
                if (selectedLink) {
                    dispatch(saveChartOfAccountsState({ group: { selectedItemName: selectedLink.name, selectedItemIndex: selectedIndex } }));
                    navigate(`../alter_accounting_groupupdate/${selectedLink.id}`);
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [selectedIndex, totalLinks, data, dataKeys, navigate, dispatch]);

    // Save state on change
    useEffect(() => {
        const selectedKey = dataKeys[selectedIndex];
        if (selectedKey && data[selectedKey]) {
            localSelectionRef.current = data[selectedKey].name;
            dispatch(saveChartOfAccountsState({ group: { selectedItemName: data[selectedKey].name, selectedItemIndex: selectedIndex } }));
        }
    }, [selectedIndex, data, dataKeys, dispatch]);

    // Scroll support
    useDropdownScroll({ dropdownRef, selectedItemIndex: selectedIndex });

    return (
        <div className='section'>
            <div className='detail border'>
                <div className='company-list-data'>
                    <div className='select-company-search-box'>
                        <p>Master Altreration</p>
                        <input className='masterInput' type="text" id='Company' placeholder='Enter Here......' autoComplete="off" />
                    </div>
                    <div className='list-of-company'>
                        <div className='title'>
                            <p style={{ textAlign: 'left', color: '#fff' }}>List of Masters</p>
                        </div>
                        <div className='container-1'>
                            <ul className='master-list'>
                                <li>
                                    <Link to="/masterchange">Change Company</Link>
                                </li>
                                <li>
                                    <Link to="alter-expand-all">Expand All</Link>
                                </li>
                                <li>
                                    <Link to="mastershowmore">Show More</Link>
                                </li>
                            </ul>
                            <hr />
                            <div className='container-2 row' id='conditional_rendering' ref={dropdownRef} style={{ overflowY: 'auto', height: '60vh' }}>
                                <div className='col d-block'>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        {
                                            dataKeys.map((itemKey, index) => {
                                                const item = data[itemKey];
                                                return (
                                                    <Link
                                                        style={{ textDecoration: 'none', textAlign: 'left', color: '#000', paddingLeft: 10 }}
                                                        to={`../alter_accounting_groupupdate/${item?.id}`}
                                                        key={index}
                                                        className={index === selectedIndex ? 'selected' : ''}
                                                        onClick={() => setSelectedIndex(index)}
                                                    >
                                                        {item?.name}
                                                    </Link>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='tomasterfooter'>
                    <Footer />
                </div>
            </div>
            <div className='help'>
                <div className='card'>
                    <h6 className='card-header'><span>F3:</span>Company</h6>
                </div>
                <div className='card'>
                    <h6 className='card-header'><span>F2:</span>Date</h6>
                </div>
            </div>
        </div>
    )
}

export default GroupList;


